import { HttpHeaders } from "@angular/common/http";

export const headers = new HttpHeaders()
  .set('Content-Type', 'application/x-www-form-urlencoded');

